import React from 'react'

const Grid = ({ className, gutter = 'false', children }) => {
  const useGutter = gutter && 'Grid--withGutter'
  return <div className={`Grid ${useGutter} ${className}`}>{children}</div>
}

const GridItem = ({ gridSize, children }) => {
  const grid = `u-size1of${gridSize}`

  return (
    <div
      className={`${[grid, 'u-md-size1of2', 'u-sm-sizeFull'].join(' ').trim()}`}
    >
      {children}
    </div>
  )
}

export { Grid, GridItem }
